import React, { useState } from 'react';
import { Menu, ChevronRight } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Logo } from './Logo';
interface AppShellProps {
  children: React.ReactNode;
}
export function AppShell({
  children
}: AppShellProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  // Simple breadcrumb logic based on path
  const pathParts = location.pathname.split('/').filter(Boolean);
  const currentPage = pathParts.length > 0 ? pathParts[0].charAt(0).toUpperCase() + pathParts[0].slice(1) : 'Inicio';
  return <div className="flex h-screen w-full bg-slate-50 overflow-hidden" data-id="element-28">
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} data-id="element-29" />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden" data-id="element-30">
        {/* Top Header */}
        <header className="h-14 bg-white shrink-0 flex items-center justify-between px-4 lg:px-8 border-b border-slate-200 relative z-10" data-id="element-31">
          <div className="flex items-center gap-4" data-id="element-32">
            <button onClick={() => setIsSidebarOpen(true)} className="lg:hidden p-1.5 text-navy-600 hover:bg-slate-100 rounded-md transition-colors" data-id="element-33">
              <Menu size={20} data-id="element-34" />
            </button>
            <div className="lg:hidden" data-id="element-35">
              <Logo variant="compact" data-id="element-36" />
            </div>

            {/* Breadcrumb Context */}
            <div className="hidden lg:flex items-center text-sm text-slate-400" data-id="element-37">
              <span data-id="element-38">WiSoft Alerts</span>
              <ChevronRight size={14} className="mx-2" data-id="element-39" />
              <span className="font-medium text-navy-950" data-id="element-40">{currentPage}</span>
            </div>
          </div>

          <div className="flex items-center gap-4" data-id="element-41">
            {/* Optional: Add global search or quick actions here in the future */}
            <div className="text-xs text-slate-400 font-medium bg-slate-100 px-2 py-1 rounded-md" data-id="element-42">
              Plan Profesional
            </div>
          </div>
        </header>

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto" data-id="element-43">{children}</main>
      </div>
    </div>;
}